import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { useIntl } from 'react-intl'
import cn from 'classnames'

import { theme } from '../../constants/theme'


export const Input = forwardRef(({ placeholder, className, ...rest }, ref) => {
  const formattedProps = {}
  const intl = useIntl()
  if (placeholder) {
    formattedProps.placeholder = intl.formatMessage({ id: placeholder })
  }

  if (rest.disabled) {
    return <CustomText className={cn(className, { disabled: rest.disabled })} {...rest}>{rest.value}</CustomText>
  }

  return <CustomInput className={cn(className, { disabled: rest.disabled })} ref={ref} {...formattedProps} {...rest} />
})

const FormikInput = ({
  field, form, placeholder, ...props
}) => {
  const formattedProps = { ...props }
  const intl = useIntl()
  if (placeholder) {
    formattedProps.placeholder = intl.formatMessage({ id: placeholder })
  }

  return (<input {...field} {...formattedProps} />)
}

export const inputStyle = {
  placeholder: css`
    color: ${theme.colors.grayDark};
    font-style: italic;
    @media (min-width: 1000px) and (max-width: 1250px) {
      font-size: small;
    }
  `,
  disabled: css`
    color: ${theme.colors.dark};
  `,
  main: css`
    border: none;
    border-bottom: ${({ disabled }) => (disabled ? 'none' : '1px solid #ABB8CB')};
    outline: none;
    background: transparent;
    padding: 9px 0;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
    transition: border-color ${theme.timings.interaction};
  `,
  focus: css`
    border: none;
    border-bottom: 1px solid ${theme.colors.blueCommon};
  `,
}


const CustomInput = styled.input`
  ${inputStyle.main}
  &:focus {
    ${inputStyle.focus}
  }
  &::placeholder {
    ${inputStyle.placeholder}
  }
  ${({ disabled }) => (disabled ? inputStyle.disabled : '')}
`

const CustomText = styled.span`
display: inline-block;
  ${inputStyle.main}
  &:focus {
    ${inputStyle.focus}
  }
  &::placeholder {
    ${inputStyle.placeholder}
  }
`

export const CustomFormikInput = styled(FormikInput)`
${inputStyle.main}
&:focus {
  ${inputStyle.focus}
}
&::placeholder {
  ${inputStyle.placeholder}
}
${({ disabled }) => (disabled ? inputStyle.disabled : '')}
width: 100%;
`
